import { render, staticRenderFns } from "./service-unpaid.vue?vue&type=template&id=33a77440&"
import script from "./service-unpaid.vue?vue&type=script&lang=js&"
export * from "./service-unpaid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports